import React, { useEffect, useMemo, useState } from 'react'
import { MemberContext } from '../lib/MemberContext'

export const MemberProvider = ({ member: memberProps, children }) => {
  const [member, setMember] = useState(memberProps)

  useEffect(() => {
    if (memberProps) setMember(memberProps)
  }, [memberProps])

  const selectedAccount = useMemo(() => {
    return member?.accounts?.find(({ _id }) => _id === member?.selectedAccountId)
  }, [member?.accounts, member?.selectedAccountId])

  const isGuest = useMemo(() => {
    return member?.isGuest
  }, [member?.isGuest])

  const isArchiveAccount = useMemo(() => {
    return selectedAccount && selectedAccount?.accountStatus !== 'active'
  }, [selectedAccount])

  return (
    <MemberContext.Provider value={{ member, selectedAccount, isGuest, isArchiveAccount }}>
      {children}
    </MemberContext.Provider>
  )
}
